import Swiper from 'swiper';
import { Pagination, Navigation, EffectFade, A11y } from 'swiper/modules';
import ControlSwiper from '../components/ControlSwiper';
import BackgroundVideo from '../components/BackgroundVideo';
import ADA from '../components/ADA';
import ConvertHeight from '../components/ConvertHeight';

const controlSwiper = new ControlSwiper();
export default class ModPanelFeatures {
  constructor(el) {
    this.$el = $(el);

    this.classes = {
      opacityZeroAndPointerEventsNone: 'opacity-0 pointer-events-none',
      swiperButton: 'swiper-button',
      transitionDelay: 'delay-ins-6',
    };
    this.convertHeight = new ConvertHeight(this.$el.find('.swiper-slide'), false);
    this.elementClasses = {
      swiperButtonDisabled: '.swiper-button-disabled',
    };

    this.dom = {
      $swiper: this.$el.find('.swiper'),
      $swiperPagination: this.$el.find('.swiper-pagination'),
      $swiperButtonNext: this.$el.find('.swiper-button-next'),
      $swiperButtonPrev: this.$el.find('.swiper-button-prev'),
      $buttonPlayPause: this.$el.find('.btn-play-pause'),
      $videos: this.$el.find('.js-video-swiper'),
      $initOpacity: this.$el.find('.init-opacity'),
      $swiperButton: this.$el.find('.swiper-button'),
      $textDisclaimer: this.$el.find('.declaimer-text'),
    };

    this.playerVideos = [];
    this.adaInstance = new ADA();
    this.init();
  }

  init() {
    this.getPlayerVideo();
    this.addSwiper();
    this.appendTextDisclaimer();
    this.convertHeight.initialize();
  }

  appendTextDisclaimer() {
    this.dom.$textDisclaimer.each((_index, elm) => {
      const $elm = $(elm);
      let $textBox;
      if ($elm.next().hasClass('text-declaimer-box')) {
        $textBox = $elm.next();
      }
      const $newDiv = $('<div>', { class: 'bg-black' });
      $elm.before($newDiv);
      $newDiv.append($elm);
      $newDiv.append($textBox);
    });
  }

  getPlayerVideo() {
    this.dom.$videos.each((index, elm) => {
      const player = new BackgroundVideo(elm);
      player.init();
      this.playerVideos.push(player);
      $(elm).attr('id', `${index}-${player.id}`);
    });
  }

  addSwiper() {
    new Swiper(this.dom.$swiper[0], {
      modules: [Pagination, Navigation, EffectFade, A11y],
      speed: 500,
      effect: 'fade',
      pagination: {
        el: this.dom.$swiperPagination[0],
        clickable: true,
      },
      navigation: {
        nextEl: this.dom.$swiperButtonNext[0],
        prevEl: this.dom.$swiperButtonPrev[0],
      },
      on: {
        init: (event) => {
          this.dom.$swiperButtonPrev.add(this.dom.$initOpacity).removeClass(this.classes.opacityZeroAndPointerEventsNone);
          this.handleStyleSwiperButtonDisabled();

          const intervalTime = setInterval(() => {
            if (this.dom.$videos.find('.is-loaded-video').length >= this.dom.$buttonPlayPause.length) {
              controlSwiper.handlePauseOrPlayVideo(event, this.$el, this.playerVideos);
              clearTimeout(intervalTime);
            }
          }, 500);
        },
        slideChange: (event) => {
          this.dom.$swiperButton.removeAttr('style');
          this.handleStyleSwiperButtonDisabled();

          if (this.dom.$swiperButton.hasClass(this.classes.transitionDelay)) {
            this.dom.$swiperButton.removeClass(this.classes.transitionDelay);
          }

          controlSwiper.handlePauseOrPlayVideo(event, this.$el, this.playerVideos);
        },
        transitionEnd: () => {
          this.adaInstance.removeAttrAriaDisabled(this.$el);
        },
      },
    });

    this.adaInstance.removeAttrAriaDisabled(this.$el);
  }

  handleStyleSwiperButtonDisabled() {
    this.$el.find(this.elementClasses.swiperButtonDisabled).css({
      'opacity': '0',
      'pointer-events': 'none',
    });
  }
}